import DropArea from './DropArea';

export default DropArea;